module.exports = __webpack_public_path__ + "static/media/community-icon-discord.eba33b09.svg";